import { formatDateMoment, getRatingImage } from 'utils/utils'

export const SORT_ALL_REVIEW = [
    {
        label: 'Sort By Rating Desc',
        key: 'rating-desc',
        name: 'sort-all-review',
    },
    {
        label: 'Sort By Rating Asc',
        key: 'rating-asc',
        name: 'sort-all-review',
    },
    {
        label: 'Sort By Likes Desc',
        key: 'like-desc',
        name: 'sort-all-review',
    },
    {
        label: 'Sort By Likes Asc',
        key: 'like-asc',
        name: 'sort-all-review',
    },
    {
        label: 'Sort By Created At Asc',
        key: 'created_at-asc',
        name: 'sort-all-review',
    },
    {
        label: 'Sort By Created At Desc',
        key: 'created_at-desc',
        name: 'sort-all-review',
    },
]

export const TABLE_ALL_REVIEW = {
    name: 'Comment',
    column: [
        {
            name: 'Nama',
            key: 'profile',
            render: ({ item }) => (
                <div className={'flex flex-row items-center space-x-4'}>
                    <img src={item?.image_url} alt={'IcUserProfile'} className={'w-8 h-8 rounded-full'} />
                    <div>
                        <p>{item.fullname}</p>
                        <p>{item.email}</p>
                    </div>
                </div>
            ),
        },
        {
            name: 'Nama Product',
            key: 'name',
        },
        {
            name: 'Rating',
            key: 'rate',
            width: 150,
            className: 'justify-center',
            render: ({ value }) => (
                <div className={'flex space-x-1'}>
                    {getRatingImage(value).map((item, index) => (
                        <img key={index} src={item} alt={'star'} className={'w-3'} />
                    ))}
                </div>
            ),
        },
        {
            name: 'Comment',
            key: 'review',
            width: 300,
            render: ({ value }) => <p className={'line-clamp-3'}>{value}</p>,
        },
        {
            name: 'Created At',
            key: 'created_at',
            render: ({ value }) => formatDateMoment(value, 'DD/MM/YYYY HH:mm'),
        },
    ],
}
